import { render } from "./CustomRadio.vue?vue&type=template&id=48160ae4&scoped=true&ts=true"
import script from "./CustomRadio.vue?vue&type=script&lang=ts"
export * from "./CustomRadio.vue?vue&type=script&lang=ts"

import "./CustomRadio.vue?vue&type=style&index=0&id=48160ae4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48160ae4"]])

export default __exports__